import { useEffect, useState } from 'react'

import { Grid } from '@mui/material'

import InputControlled from 'components/Controllers/Input'
import AutocompleteControlled from 'components/Controllers/Autocomplete'

import { documentTypes, accountTypes } from '../options'

import { getBanks } from 'services/payments'

const PSEForm = (props) => {
  const { control } = props

  const [banks, setBanks] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getBanks()
        if (response.data.status === 'success') {
          setBanks(response.data.data.items)
        }
      } catch (error) {
        console.error('Fetch error: ', error)
      }
    }

    fetchData()
  }, [])

  return (
    <Grid container spacing={2} pr={{ md: 8 }} pb={{ md: 1 }}>
      <Grid item xs={12} md={6}>
        <AutocompleteControlled label="Banco" name="bank" control={control} rules={{ required: true }} options={banks} disabled={!banks.length} />
      </Grid>
      <Grid item xs={12} md={6}>
        <AutocompleteControlled label="Tipo de cuenta" name="account_type" control={control} rules={{ required: true }} options={accountTypes} />
      </Grid>
      <Grid item xs={12}>
        <InputControlled label="Número de cuenta" name="account_number" control={control} rules={{ required: true }} inputProps={{ maxLength: 16 }} />
      </Grid>
      <Grid item xs={12} md={6}>
        <InputControlled label="Nombres" name="customer_firstname" control={control} rules={{ required: true }} inputProps={{ maxLength: 20 }} />
      </Grid>
      <Grid item xs={12} md={6}>
        <InputControlled label="Apellidos" name="customer_lastname" control={control} rules={{ required: true }} inputProps={{ maxLength: 20 }} />
      </Grid>
      <Grid item xs={3} md={6}>
        <AutocompleteControlled label="Tipo" name="customer_document_type" control={control} rules={{ required: true }} options={documentTypes} />
      </Grid>
      <Grid item xs={9} md={6}>
        <InputControlled label="N° Documento" name="customer_document_number" control={control} rules={{ required: true }} inputProps={{ maxLength: 10 }} />
      </Grid>
    </Grid>
  )
}

export default PSEForm
